function possuiEspacoEmBranco(s) {
  return /\s/g.test(s);
}

export default function obterIniciais(nome) {
  if (possuiEspacoEmBranco(nome)) {

    //remove múltiplos espaços em branco deixando apenas um e depois faz o split
    const partesNome = nome.replace(/\s+/g, ' ').trim().split(' ');

    const iniciais = partesNome.map(part => part[0].toUpperCase());
    return iniciais.join('');
  }
  return nome
}

export function gerarIdentificador(paciente) {

  let splitDate = paciente.dataNascimento.split("-");
  let iniciaisNome = obterIniciais(paciente.nome);
  let iniciaisNomeMae = obterIniciais(paciente.nomeMae);

  let codigoPaciente =
    (iniciaisNome +
      iniciaisNomeMae +
      splitDate[0] +
      splitDate[1] +
      splitDate[2].split("T")[0]).toUpperCase()

  return codigoPaciente;
};